import React from "react";
import spiderWebPicture from "../assests/Spider-Web.png";

function ThemeSection() {
  return (
    <section className="theme-section">
      <figure className="spider-web-fig">
        <img
          className="spider-web-img"
          src={spiderWebPicture}
          alt="A Spider Web Picture"
        />
        <figcaption className="fig-caption">A Spider Web Picture</figcaption>
      </figure>
    </section>
  );
}

export default ThemeSection;
